import React, { useMemo } from "react";
import Tab from "./Tab";
import type {
  OptionTimeframe,
  TradeDirection,
} from "../../../../../components/DashBoard/GTT/gttTypes";
import "./ordersTabs.scss";
import type { BalanceDisplayProps, OrderPayload } from "../../../../../models/orders";

export type OrdersTabsProps = {
  optionTimeframe: OptionTimeframe[];
  selected: OptionTimeframe;
  toggleOptionTimeframe: (timeframe: OptionTimeframe) => void;
  disabled?: boolean;
  token: number;
  exchange: string;
  tradeDirection: TradeDirection;
  variety: OrderPayload["variety"];
  ltp: number;
  isEditable: boolean;
  quantity:number
  segMentId:number
  price:number
};

const OrdersTabs: React.FC<OrdersTabsProps> = ({
  optionTimeframe,
  selected,
  toggleOptionTimeframe,
  disabled = false,
  token,
  exchange,
  tradeDirection,
  ltp,
  isEditable,
  quantity,
  segMentId,
  price
}) => {
  const memoizedLTP = useMemo(() => ltp, []);

  // if price == -1 mean we can say type was market else we had value and we need to send that data

  return (
    <div className="d-flex px-5 text-color fw-bolder border-bottom gtt-tabs-border-white">
      {optionTimeframe.map((timeframe) => (
        <Tab
          key={timeframe}
          timeframe={timeframe}
          isSelected={selected === timeframe}
          isDisabled={disabled || isEditable} // Disable if `isEditable` is false
          onClick={() => {
            if (!isEditable) {
              toggleOptionTimeframe(timeframe); // Only allow toggling if editable
            }
          }}
          exchange={exchange}
          ltp={memoizedLTP}
          variety={"RL-MKT"} // TODO: Update this if necessary in the future
          selected={timeframe}
          token={token}
          tradeDirection={tradeDirection}
          quantity={quantity}
          segMentId={segMentId}
          price={price}
        />
      ))}
    </div>
  );
};

export default OrdersTabs;
